import { useMemo } from "react";

import { useFlowVersionMockableNodes } from "src/api/flowVersionQueries";
import { hasAgentNodeWithLiveData } from "src/flowContainer/RunFlowButton/utils";
import { useAuthoringContext } from "src/router/routerContextHooks";

export const useChildHasAgentNode = () => {
  const { version } = useAuthoringContext();
  const childFlowVersionIds = useMemo(() => {
    return version.child_versions?.flatMap((childFlow) => childFlow.id) ?? [];
  }, [version]);

  const childMockableNodes = useFlowVersionMockableNodes(
    childFlowVersionIds.map((id) => ({ nodeId: id, flowVersionId: id })),
  );

  const hasAgentNodes = useMemo(() => {
    return Object.values(childMockableNodes).some((nodes) =>
      hasAgentNodeWithLiveData(nodes),
    );
  }, [childMockableNodes]);

  return hasAgentNodes;
};
